<template>
	<v-col class="purchase-serial">
		<ModalConfirm ref="modalConfirm" :msg="msgConfirm" @action="processPurchase"></ModalConfirm>
		<ModalSuccess ref="modalSuccess" :msg="msgSuccess" :link="link" :routerType="routerType"></ModalSuccess>
		<ModalFailed ref="modalFailed" :msg="msgFailed"></ModalFailed>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Penukaran Serial</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-credit-card-plus</v-icon>
			<div class="pl-2">Transaksi Serial</div>
			<div class="px-2">/</div>
			<div>Penukaran Serial</div>
		</div>

		<div class="mt-5">
			<v-row class="mb-3 justify-end">
				<v-col cols="12" sm="5" md="3" xl="2" class="">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-row>
							<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
								<img class="img-fluid" src="/assets/icon/saldo.png">
							</v-col>
							<v-col cols="10" sm="9" md="9">
								<div class="font-size-14 blue--text font-weight-500">{{ ewalletSummary.ewallet_product_balance | toRupiah }}</div>
								<div class="font-size-10 cl-grey">Total Saldo Belanja</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>

			<div class="body-transaction-product">
				<div>
					<div class="font-size-10 cl-grey font-weight-500">
						<v-icon small color="grey">mdi-card-bulleted</v-icon>
						<span class="pl-2">Pilih Jenis Serial</span>
					</div>
					<v-radio-group class="mt-2" v-model="checkedSerial">
						<v-row class="ml-0">
							<template v-for="serial in filterSerialCategory(listSerialCategory, myProfile.network_type)">
								<v-col cols="12" sm="4" md="4" xl="2" class="pl-0 pb-0 flex-stretch" :key="serial.id" v-if="serial.serial_type_id !== '8'">
									<v-card class="pa-3 elevation-0 rounded-lg hover-shadow fill-height" @click="checkSerial(serial.id, serial.serial_type_price, serial.serial_type_id)">
										<v-row>
											<v-col cols="2" sm="2" md="2" class="my-auto">
												<v-radio on-icon="mdi-circle-slice-8" off-icon="mdi-checkbox-blank-circle-outline" class="mt-0" :value="serial.id" @click="checkSerial(serial.id, serial.serial_type_price, serial.serial_type_id)"></v-radio>
											</v-col>
											<v-col cols="8" sm="8" md="8">
												<v-row>
													<v-col cols="12" md="12" class="pl-0 pl-sm-3 my-auto">
														<div class="font-size-10 cl-grey">Serial</div>
														<div class="font-size-12 font-size-xs-11 cl-primary font-weight-500 text-capitalize">{{ (serial.serial_type_label === 'repeatorder') ? 'Repeat Order' : serial.serial_type_label }}</div>
													</v-col>
												</v-row>
											</v-col>
											<v-col cols="2" sm="2" md="2" class="pl-0 my-auto">
												<v-img :src="'/assets/icon/serial_'+serial.serial_type_name+'.svg'"></v-img>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</template>
						</v-row>
					</v-radio-group>
				</div>

				<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
					<div v-if="checkedSerial == 1 || checkedSerial == 2">
						<div v-if="checkedSerial == 1">
							<!-- serial Aktivasi -->
							<div class="pt-3 font-size-10 cl-grey font-weight-500">
								<v-icon small color="grey">mdi-card-bulleted</v-icon>
								<span class="pl-2">Pilih Serial Aktivasi</span>
							</div>
							<v-radio-group class="mt-2" v-model="checkedActivation">
								<v-row class="ml-0">
									<v-col cols="12" sm="4" md="4" xl="2" class="pl-0 pb-0" v-for="serial in serialChildActivation" :key="serial.id">
										<v-card class="pa-3 elevation-0 rounded-lg hover-shadow fill-height" @click="checkActivation(serial)">
											<v-row>
												<v-col cols="2" sm="2" md="2" class="my-auto">
													<v-radio on-icon="mdi-circle-slice-8" off-icon="mdi-checkbox-blank-circle-outline" class="mt-0" :value="serial.id" @click="checkActivation(serial)"></v-radio>
												</v-col>
												<v-col cols="8" sm="8" md="8" class="my-auto">
													<v-row>
														<v-col cols="12" md="12" class="pl-0 pl-sm-3">
															<div class="font-size-10 cl-grey">Serial Aktivasi</div>
															<div class="font-size-13 font-size-xs-11 cl-primary font-weight-500">{{ serial.serial_type_label }}</div>
														</v-col>
													</v-row>
												</v-col>
												<v-col cols="2" sm="2" md="2" class="pl-0 my-auto">
													<v-img :src="'/assets/icon/'+serial.serial_type_name+'.svg'"></v-img>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
								</v-row>
							</v-radio-group>
						</div>

						<div v-if="checkedSerial == 2">
							<!-- serial upgrade -->
							<div class="pt-3 font-size-10 cl-grey font-weight-500">
								<v-icon small color="grey">mdi-card-bulleted</v-icon>
								<span class="pl-2">Pilih Serial Upgrade</span>
							</div>
							<v-radio-group class="mt-2" v-model="checkedUpgrade">
								<v-row class="ml-0">
									<v-col cols="12" sm="4" md="4" xl="2" class="pl-0 pb-0" v-for="serial in filterSerial(serialChildUpgrade, myProfile.network_type)" :key="serial.id">
										<v-card class="pa-3 elevation-0 rounded-lg hover-shadow" @click="checkUpgrade(serial)">
											<v-row>
												<v-col cols="2" sm="2" md="2" class="my-auto">
													<v-radio on-icon="mdi-circle-slice-8" off-icon="mdi-checkbox-blank-circle-outline" class="mt-0" :value="serial.id" @click="checkUpgrade(serial)"></v-radio>
												</v-col>
												<v-col cols="8" sm="8" md="8" class="my-auto">
													<v-row>
														<v-col cols="12" md="12" class="pl-0 pl-sm-3">
															<div class="font-size-10 cl-grey">Serial Upgrade</div>
															<div class="font-size-12 font-size-xs-11 cl-primary font-weight-500">{{ serial.serial_type_label }}</div>
														</v-col>
													</v-row>
												</v-col>
												<v-col cols="2" sm="2" md="2" class="pl-0 my-auto">
													<v-img src="/assets/icon/serial_upgrade.svg"></v-img>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
								</v-row>
							</v-radio-group>
						</div>

						<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
							<div class="pt-3 pb-5" v-if="checkedActivation || checkedUpgrade">
								<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
									<v-row>
										<v-col cols="12" sm="3" class="my-auto">
											<div class="font-size-10 cl-grey">Harga Serial</div>
											<div class="font-size-13 font-size-xs-11 cl-grey font-weight-500">{{ serialPrice | toRupiah }}</div>
										</v-col>
										<v-col cols="6" sm="3" md="2" class="pt-0 pt-sm-3 my-auto">
											<v-row class="pt-2 justify-space-end align-center">
												<v-col cols="4" sm="3" md="3" xl="3" class="">
													<v-btn elevation="0" small @click="decQty" class="px-0" style="min-width: 33px;">
														<v-icon color="error">mdi-minus-circle-outline</v-icon>
													</v-btn>
												</v-col>
												<v-col cols="4" sm="6" md="6" xl="6" class="px-0">
													<div class="">
														<v-text-field dense hide-details="auto" v-model="serialQty" @keypress="onlyNumber" @keyup="addTotal" @paste.prevent :rules="rules.inputQty"></v-text-field>
													</div>
												</v-col>
												<v-col cols="4" sm="3" md="3" xl="3" class="">
													<v-btn elevation="0" small @click="addQty" class="px-0 flex-shrink-0" style="min-width: 33px;">
														<v-icon color="primary">mdi-plus-circle-outline</v-icon>
													</v-btn>
												</v-col>
											</v-row>
										</v-col>
										<v-col cols="12" sm="6" md="7" class="pt-0 pt-sm-3 text-right my-auto">
											<div class="font-size-10 cl-grey">Total</div>
											<div class="font-size-15 font-size-xs-11 cl-primary font-weight-500">{{ serialTotal | toRupiah }}</div>
										</v-col>
									</v-row>
								</v-card>
							</div>
						</v-scroll-x-reverse-transition>
					</div>
				</v-scroll-x-reverse-transition>

				<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
					<div class="pt-3 pb-5" v-if="checkedSerial == 3">
						<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
							<v-row>
								<v-col cols="12" sm="3" class="my-auto">
									<div class="font-size-10 cl-grey">Harga Serial</div>
									<div class="font-size-13 font-size-xs-11 cl-grey font-weight-500">{{ serialPrice | toRupiah }}</div>
								</v-col>
								<v-col cols="6" sm="3" md="2" class="pt-0 pt-sm-3 my-auto">
									<v-row class="pt-2 justify-space-end align-center">
										<v-col cols="4" sm="3" md="3" xl="3" class="">
											<v-btn elevation="0" small @click="decQty" class="px-0" style="min-width: 33px;">
												<v-icon color="error">mdi-minus-circle-outline</v-icon>
											</v-btn>
										</v-col>
										<v-col cols="4" sm="6" md="6" xl="6" class="px-0">
											<div class="">
												<v-text-field dense hide-details="auto" v-model="serialQty" @keypress="onlyNumber" @keyup="addTotal" @paste.prevent :rules="rules.inputQty"></v-text-field>
											</div>
										</v-col>
										<v-col cols="4" sm="3" md="3" xl="3" class="">
											<v-btn elevation="0" small @click="addQty" class="px-0 flex-shrink-0" style="min-width: 33px;">
												<v-icon color="primary">mdi-plus-circle-outline</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" sm="6" md="7" class="pt-0 pt-sm-3 text-right my-auto">
									<div class="font-size-10 cl-grey">Total</div>
									<div class="font-size-15 font-size-xs-11 cl-primary font-weight-500">{{ serialTotal | toRupiah }}</div>
								</v-col>
							</v-row>
						</v-card>
					</div>
				</v-scroll-x-reverse-transition>
			</div>
			<div class="footer-transaction-product rounded-lg">
				<div class="d-flex">
					<v-col cols="6" class="pa-0">
						<div class="font-size-11 product-name">Total</div>
						<div class="font-size-14 cl-primary">{{ serialTotal | toRupiah }}</div>
					</v-col>
					<v-col cols="6" class="pa-0 text-right my-auto">
						<v-btn large width="120" depressed color="primary" class="rounded-lg" :disabled="!checkData" @click="showConfirm">
							<v-icon>mdi-cart-arrow-right</v-icon>
							<span class="pl-2">Beli</span>
						</v-btn>
					</v-col>
				</div>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalConfirm from '@/components/modals/vo/ModalConfirm';
import ModalSuccess from '@/components/modals/vo/ModalSuccess';
import ModalFailed from '@/components/modals/vo/ModalFailed';

export default {
	components: {
		ModalConfirm, ModalSuccess, ModalFailed
	},
	data() {
		return {
			serialChildActivation: [],
			serialChildUpgrade: [],
			checkedSerial: '',
			checkedActivation: '',
			checkedUpgrade: '',
			selectedSerial: '',
			serialPrice: '',
			serialQty: 1,
			serialTotal: '',
			msgConfirm: "Yakin ingin memproses pembelian?",
			msgSuccess: "Selamat! Anda berhasil melakukan penukaran serial. Untuk detail transaksi bisa di",
			msgFailed: "Mohon maaf transaksi Anda gagal. Silakan ulangi kembali untuk melakukan penukaran serial Anda",
			link: 'transaction-serial-report',
			routerType: '',
			isActiveMember: false,
			rules: {
				inputQty: [
					v => parseFloat(v) < 1001 || 'Jumlah pembelian maksimal 1000',
				],
			}
		}
	},
	computed: {
		...mapState('serial', ['listSerialCategory', 'listSerialCategoryAll']),
		...mapState('ewallet', ['ewalletSummary']),
		...mapState('profile', ['myProfile']),

		checkData() {
			if ( this.checkedSerial  == 3 ) {
				return true
			} else if ( this.checkedSerial  == 1 || this.checkedSerial  == 2 )  {
				if ( this.checkedActivation || this.checkedUpgrade ) {
					return true
				} else {
					return false
				}
			} else {
				return false
			}
		},
	},
	methods: {
		...mapActions('serial', ['getSerialCategory']),
		...mapActions('transactionSerial', ['addTransactionSerial']),
		...mapActions('ewallet', ['getEwalletSummary']),
		...mapActions('profile', ['getProfile', 'getProfileMitra', 'getProfilePramitra']),

		filterSerialCategory(data, type) {
			if (this.isActiveMember) {
				if (type === 'diamond') {
					return data.filter(x => x.serial_type_name !== 'upgrade')
				} else {
					return data
				}
			} else {
				return data.filter(x => x.serial_type_name === 'aktivasi')
			}
		},
		
		filterSerial(data, type) {
			if (type === 'silver' || type === 'repeat_order') {
				return data
			} else {
				const serialPart = []
				data.forEach(el => {
					let parts = el.serial_type_name.split('_to_')
					if (parts[0] === type) {
						serialPart.push(el)
					}
				});
				return serialPart
			}
		},

		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			else this.isActiveMember = true
		},

		getData() {
			this.getSerialCategory().then(() => {
				this.getSerialChild()
			})
			this.getEwalletSummary()
			this.resetSerial()
		},

		getSerialChild() {
			let numb = 1
			this.listSerialCategory.forEach( (el) => {
				if (el.serial_type_has_child && el.serial_type_name == 'aktivasi') {
					this.serialChildActivation = []
					el.serial_type_child_detail.forEach((val) => {
						val['id'] = numb++
						this.serialChildActivation.push(val)
					})
				}
				else if (el.serial_type_has_child && el.serial_type_name == 'upgrade') {
					this.serialChildUpgrade = []
					el.serial_type_child_detail.forEach((val) => {
						val['id'] = numb++
						this.serialChildUpgrade.push(val)
					})
				}
			});
		},

		addQty() {
			if (this.serialQty >= 0) {
				this.serialQty++
				this.serialTotal = this.serialQty * this.serialPrice
			}
		},

		decQty() {
			if (this.serialQty > 1) {
				this.serialQty--
				this.serialTotal = this.serialQty * this.serialPrice
			}
		},

		addTotal() {
			if (this.serialQty <= 0) {
				this.serialQty = 1
			}
			this.serialTotal = this.serialQty * this.serialPrice
		},

		checkSerial(serial, price, id) {
			if (this.checkedSerial == serial) {
				this.checkedSerial = ''
				this.serialPrice = 0
			}	else {
				this.checkedSerial = serial
				if (serial === 1 || serial === 2) this.serialPrice = 0
				else this.serialPrice = price
			}
			this.serialQty = 1
			this.checkedActivation = ''
			this.checkedUpgrade = ''
			this.selectedSerial = id
			this.addTotal()
		},

		checkActivation(serial) {
			if (this.checkedActivation == serial.id) {
				this.checkedActivation = ''
				this.serialPrice = 0
			}	else {
				this.checkedActivation = serial.id
				if (serial === 2 || serial === 3) this.serialPrice = 0
				else this.serialPrice = serial.serial_type_price
			}

			this.serialQty = 1
			this.selectedSerial = serial.serial_type_id
			this.addTotal()
		},

		checkUpgrade(serial) {
			if (this.checkedUpgrade == serial.id) {
				this.checkedUpgrade = ''
				this.serialPrice = 0
			}	else {
				this.checkedUpgrade = serial.id
				if (serial === 2 || serial === 3) this.serialPrice = 0
				else this.serialPrice = serial.serial_type_price
			}

			this.serialQty = 1
			this.selectedSerial = serial.serial_type_id
			this.addTotal()
		},

		resetSerial() {
			this.checkedSerial = ''
			this.checkedActivation = ''
			this.checkedUpgrade = ''
			this.selectedSerial = ''
			this.serialTotal = ''
			this.serialChildUpgrade = []
			this.serialChildActivation = []
		},

		showConfirm() {
			this.$refs.modalConfirm.modalShow()
		},

		processPurchase() {
			if ( this.checkedSerial  == 1 ) {
				let params = {}
				params = {serial_qty: this.serialQty, serial_type_id: this.selectedSerial}
				this.$refs.modalConfirm.loadingButton()
				this.addTransactionSerial(params).then(() => {
					this.routerType = "aktivasi"
					this.serialPrice = 0
					this.serialTotal = 0
					this.$refs.modalConfirm.normalButton()
					this.$refs.modalConfirm.modalHide()
					this.$refs.modalSuccess.modalShow()
					this.getData()
				}).catch(() => {
					this.$refs.modalConfirm.normalButton()
					this.$refs.modalConfirm.modalHide()
					this.$refs.modalFailed.modalShow()
				})
			}
			if ( this.checkedSerial  == 2 ) {
				let params = {}
				params = {serial_qty: this.serialQty, serial_type_id: this.selectedSerial}
				this.$refs.modalConfirm.loadingButton()
				this.addTransactionSerial(params).then(() => {
					this.routerType = "upgrade"
					this.serialPrice = 0
					this.serialTotal = 0
					this.$refs.modalConfirm.normalButton()
					this.$refs.modalConfirm.modalHide()
					this.$refs.modalSuccess.modalShow()
					this.getData()
				}).catch(() => {
					this.$refs.modalConfirm.normalButton()
					this.$refs.modalConfirm.modalHide()
					this.$refs.modalFailed.modalShow()
				})
			}
			if ( this.checkedSerial  == 3 ) {
				let params = {}
				params = {serial_qty: this.serialQty, serial_type_id: this.selectedSerial}
				this.$refs.modalConfirm.loadingButton()
				this.addTransactionSerial(params).then(() => {
					this.routerType = "ro"
					this.serialPrice = 0
					this.serialTotal = 0
					this.$refs.modalConfirm.normalButton()
					this.$refs.modalConfirm.modalHide()
					this.$refs.modalSuccess.modalShow()
					this.getData()
				}).catch(() => {
					this.$refs.modalConfirm.normalButton()
					this.$refs.modalConfirm.modalHide()
					this.$refs.modalFailed.modalShow()
				})
			}
		}
	},

	async created(){
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)
		await this.checkMemberActivation(data)

		if (this.isActiveMember) await this.getProfileMitra()
		else await this.getProfilePramitra()
		
		this.$store.dispatch('setPageTitle', `Beli Serial`)
		this.getData()
	}
};
</script>
